import React, { useMemo } from 'react';
import { cn } from '~/lib/utils';

const atozLogo = '/theme/atoz/logos/logo-small.svg';
const daviesLogo = '/theme/davies/logos/logo-small.svg';
const glsLogo = '/theme/gls/logos/logo-small.svg';
const hopeLogo = '/theme/hope/logos/logo-large-white.svg';
const ldaLogo = '/theme/lda/logos/logo-small.svg';
const marketplaceLogo = '/theme/marketplace/logos/logo-small.svg';
const philipLogo = '/theme/philip/logos/logo-horizontal.svg';
const spaLogo = '/theme/spa4/logos/logo-small.svg';
const findelLogo = '/theme/findel/logos/logo-small.svg';

type Props = {
  theme: BrandTheme;
};

const themeMap = {
  atoz: {
    logo: atozLogo,
    alt: 'AtoZ',
    width: 434,
    height: 237,
  },
  davies: {
    logo: daviesLogo,
    alt: 'Davies Sports',
    width: 828,
    height: 234,
  },
  gls: {
    logo: glsLogo,
    alt: 'GLS',
    width: 169,
    height: 55,
  },
  hope: {
    logo: hopeLogo,
    alt: 'Hope is all you need',
    width: 164,
    height: 100,
  },
  lda: {
    logo: ldaLogo,
    alt: 'LDA',
    width: 100,
    height: 50,
  },
  international: {
    logo: findelLogo,
    alt: 'International',
    width: 268,
    height: 88,
  },
  philip: {
    logo: philipLogo,
    alt: 'Philip Harris',
    width: 88,
    height: 85,
  },
  spa: {
    logo: spaLogo,
    alt: 'SPA',
    width: 462,
    height: 328,
  },
  findel: {
    logo: findelLogo,
    alt: 'Findel',
    width: 268,
    height: 88,
  },
  punchout: {
    logo: findelLogo,
    alt: 'Findel',
    width: 268,
    height: 88,
  },
  marketplace: {
    logo: marketplaceLogo,
    alt: 'Marketplace',
    width: 268,
    height: 88,
  },
  default: {
    logo: findelLogo,
    alt: 'Default',
    width: 268,
    height: 88,
  },
};

export default function Logo({ theme }: Readonly<Props>) {
  const logoProps = useMemo(() => themeMap[theme] || {}, [theme]);

  if (!logoProps?.logo) return <></>;

  return (
    <div
      className={cn('site-header-logo', {
        'rounded-b-[10px] border-b-2 border-l-2 border-r-2 bg-white drop-shadow-md transition-all duration-300 hover:drop-shadow-sm':
          theme === 'atoz',
        'max-w-[110px]': theme === 'atoz',
        'my-2 max-w-[140px]': theme === 'davies',
        'max-w-[169px]': theme === 'gls',
        'max-w-[75px]': theme === 'philip',
        'max-w-[78px]': theme === 'lda',
        'max-w-[78px] md:-my-1 md:max-w-[90px]': theme === 'spa',
        'max-w-[82px]': theme === 'hope',
        'max-w-[154px]':
          theme === 'findel' ||
          theme === 'international' ||
          theme === 'punchout' ||
          theme === 'marketplace',
      })}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={logoProps.logo}
        alt={logoProps.alt}
        width={logoProps.width}
        height={logoProps.height}
        data-testid="site-header-logo"
      />
    </div>
  );
}
